import { render, staticRenderFns } from "./RightSideModal.vue?vue&type=template&id=a3a23296&scoped=true"
import script from "./RightSideModal.vue?vue&type=script&lang=ts"
export * from "./RightSideModal.vue?vue&type=script&lang=ts"
import style0 from "./RightSideModal.vue?vue&type=style&index=0&id=a3a23296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3a23296",
  null
  
)

export default component.exports